import { Pipe, PipeTransform } from '@angular/core';
import { FormStatusCode } from '@nrwl/rx-models';

export type FormStatusColorClass = 'yellow' | 'violet' | 'red' | 'green' | 'orange' | '';

const FORM_STATUS_COLORS: Record<Exclude<FormStatusColorClass, ''>, string> = {
  yellow: '#fbb232',
  violet: '#5857d4',
  red: '#f83e30',
  green: '#4bfd47',
  orange: '#B35C7A',
};

export function getFormStatusColorClass(
  status: number | null | undefined,
  sharedWithPatient = false,
): FormStatusColorClass {
  switch (status) {
    case FormStatusCode.ClientSubmitted:
      return 'yellow';
    case FormStatusCode.Incomplete:
      return sharedWithPatient ? 'yellow' : 'violet';
    case FormStatusCode.DirectorReview:
    case FormStatusCode.SupervisorReview:
      return 'red';
    case FormStatusCode.Complete:
      return 'green';
    case FormStatusCode.OngoingPlan:
      return 'orange';
    default:
      return '';
  }
}

export function getFormStatusColor(
  status: number | null | undefined,
  sharedWithPatient = false,
): string {
  const colorClass = getFormStatusColorClass(status, sharedWithPatient);

  return colorClass ? FORM_STATUS_COLORS[colorClass] : '';
}

@Pipe({
  name: 'formStatusColor',
})
export class FormStatusColorPipe implements PipeTransform {
  transform(form: any): string {
    return getFormStatusColor(form?.status, Boolean(form?.shared_with_patient));
  }
}
